import { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import mapboxgl from "mapbox-gl";
import { SearchBox } from "@mapbox/search-js-react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import "./BerthLocationModal.css";

export const BerthLocationModal = ({ open, handleClose, handleFinalPlace }) => {
  const mapContainerRef = useRef();
  const mapInstanceRef = useRef();
  const markerRef = useRef(null);

  const [isLocationPermissionAllowed, setIsLocationPermissionAllowed] = useState(false);

  const [mapLoaded, setMapLoaded] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [coordinates, setCoordinates] = useState([null]);
  const [dragCoordinates, setDragCoordinates] = useState(null);
  const [fullAddress, setFullAddress] = useState(null);

  const locationAllowed = async (position) => {
    setIsLocationPermissionAllowed(true);

    const { latitude, longitude } = position.coords;
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_DEFAULT_PUBLIC_TOKEN;

    const map = new mapboxgl.Map({
      container: mapContainerRef.current, // container
      center: [longitude, latitude], // starting position [lng, lat]
      zoom: 10, // starting zoom
    });

    mapInstanceRef.current = map;
    mapInstanceRef.current.addControl(new mapboxgl.NavigationControl());

    mapInstanceRef.current.on("load", () => {
      setMapLoaded(true);
    });

    const marker = new mapboxgl.Marker({
      draggable: true,
    })
      .setLngLat([longitude, latitude])
      .addTo(map);

    function onDragEnd() {
      setDragCoordinates(marker.getLngLat());
    }

    marker.on("dragend", onDragEnd);

    markerRef.current = marker;
  };

  const locationBlocked = () => {
    setIsLocationPermissionAllowed(false);

    toast.error(
      "Please allow location permission to know your current location."
    );
  };

  const loadMap = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        locationAllowed,
        locationBlocked
      );
      return;
    } else {
      toast.error(
        "It seems like Geolocation, which is required for this page, is not enabled in your browser. Please use a browser which supports it."
      );
      return;
    }
  };

  useEffect(() => {
    if(!mapContainerRef.current) {
      return;
    }
    
    loadMap();
  }, [mapContainerRef.current]);

    function validateSearchQuery(query) {
      const regex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s,.\-#/]+$/;
  
      if (!regex.test(query)) {
        toast.error("Please enter a valid search query.");
  
        return;
      }
  
      return query
    }
  

  const handleSelectedPlace = (e) => {
    if (!isLocationPermissionAllowed) {
      toast.error(
        "Please allow location permission to set the berth location."
      );
      return;
    }
    setCoordinates(e?.features[0]?.geometry?.coordinates);
    setFullAddress(e);

    // mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_DEFAULT_PUBLIC_TOKEN;

    // const map = new mapboxgl.Map({
    //   container: mapContainerRef.current, // container ID
    //   center: e?.features[0]?.geometry?.coordinates, // starting position [lng, lat]
    //   zoom: 10, // starting zoom
    // });

    // mapInstanceRef.current = map;

    // const marker = new mapboxgl.Marker({
    //   draggable: true,
    // })
    //   .setLngLat(e?.features[0]?.geometry?.coordinates)
    //   .addTo(map);

    // function onDragEnd() {
    //   console.log("marker dargged!!")
    //   setDragCoordinates(marker.getLngLat());
    // }

    // marker.on("dragend", onDragEnd);

    mapInstanceRef.current.flyTo({
      center: e.features[0]?.geometry?.coordinates,
      zoom: 10,
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    })

    if (markerRef.current) {
      markerRef.current.setLngLat(e.features[0]?.geometry?.coordinates);
    }
    return;
  };

  const handleFinalLocation = () => {
    handleFinalPlace(fullAddress, dragCoordinates);
    return;
  };

  return (
    <Modal keepMounted open={open} onClose={handleClose}>
      <Box className="locationModal">
        <Grid container spacing={2} className="searchBoxContainer">
          <Grid item xs={12} md={8} sx={{ pt: 2 }}>
            <SearchBox
              className="searchBox"
              placeholder="Please enter your berth location"
              autofocus
              accessToken={process.env.REACT_APP_MAPBOX_DEFAULT_PUBLIC_TOKEN}
              map={mapInstanceRef.current}
              mapboxgl={mapboxgl}
              value={inputValue}
              onChange={(d) => {
                setInputValue(d);
              }}
              interceptSearch={validateSearchQuery}              
              onRetrieve={(e) => handleSelectedPlace(e)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              disabled={coordinates[0] === null}
              sx={{ ml: 3 }}
              size="small"
              variant="outlined"
              color="gray"
              onClick={handleFinalLocation}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>

        <div className="deliveryMap" ref={mapContainerRef}>
          {/* <Map height="400px" directions={directions} /> */}
        </div>
      </Box>
    </Modal>
  );
};
